import { Layout } from 'antd';
import cx from 'classnames';
import { ReactNode } from 'react';
import styles from './Column.module.less';
import { Full } from './Full.component';

const { Content } = Layout;

interface ColumnPageProps {
  children: ReactNode;
  navMenu: ReactNode;
  withPadding?: boolean;
  overflowHidden?: boolean;
}

export const Column = ({
  withPadding = true,
  children,
  navMenu,
  overflowHidden,
}: ColumnPageProps) => (
  <Full noPadding>
    <Layout>
      {navMenu}
      <Content
        className={cx(styles.container, {
          [styles.withPadding]: withPadding,
          [styles.contentWrapperOverflowHidden]: overflowHidden,
        })}
      >
        {children}
      </Content>
    </Layout>
  </Full>
);
